import { useQueryClient } from '@tanstack/react-query';

// frontend-base's site QueryClient uses react-query's defaults: every query is
// refetched whenever the window regains focus and failed queries are retried
// 3 times. The masquerade bar's ['masquerade', courseId] query fails whenever
// the LMS session is gone (signed in elsewhere: PREVENT_CONCURRENT_LOGINS; the
// JWT still works for everything else): the LMS 302s it to the sign-in page,
// the browser blocks that cross-origin redirect, and each focus produced a
// burst of failing requests. Fetch it once per page instead; the bar hides on
// failure, as frontend-base intends.
//
// Rendered in the header, before the masquerade bar, so the defaults are in
// place when that query is created. Renders nothing.
const QueryDefaults = () => {
  const queryClient = useQueryClient();
  queryClient.setQueryDefaults(['masquerade'], {
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: 5 * 60 * 1000,
  });
  return null;
};

export default QueryDefaults;
